import R from 'ramda'

import actionTypes from './actionTypes'

import addNewFolder from './helpers/addNewFolder'
import adjustFolder from './helpers/adjustFolder'
import replaceChangedFolders from './helpers/replaceChangedFolders'
import withoutFolderId from './helpers/withoutFolderId'
import withoutFolderItem from './helpers/withoutFolderItem'
import {
  addPublishedFolder,
  removePublishedFolder,
  withFolderPublished,
  withFolderUnpublished,
} from './helpers/publishedFolders'
import { adjustFolderShares, removeFolderShares } from './helpers/sharedFolders'

export default function foldersReducer(state, action) {
  const { type, payload } = action

  return R.cond([
    [
      R.equals(actionTypes.setFolders),
      () => ({ ...state, myFolders: payload }),
    ],
    [
      R.equals(actionTypes.setCurrentFolderId),
      () => ({ ...state, currentFolderId: payload }),
    ],
    [
      R.equals(actionTypes.createFolder),
      () => ({
        ...state,
        myFolders: addNewFolder(payload, state.myFolders),
      }),
    ],
    [
      R.equals(actionTypes.updateFolder),
      () => ({
        ...state,
        myFolders: adjustFolder(
          {
            id: payload.id,
            name: payload.name,
            description: payload.description,
          },
          state.myFolders
        ),
      }),
    ],
    [
      R.equals(actionTypes.updateChangedFolders),
      () => ({
        ...state,
        myFolders: replaceChangedFolders({
          changedFolders: payload,
          folders: state.myFolders,
        }),
      }),
    ],
    [
      R.equals(actionTypes.addPublishedFolder),
      () => ({
        ...state,
        myFolders: withFolderPublished({
          folderId: payload.id,
          eslPublishedAt: payload.eslPublishedAt,
          myFolders: state.myFolders,
        }),
        publishedFolders: addPublishedFolder({
          folder: payload,
          publishedFolders: state.publishedFolders,
        }),
      }),
    ],
    [
      R.equals(actionTypes.removePublishedFolder),
      () => ({
        ...state,
        myFolders: withFolderUnpublished({
          folderId: payload,
          myFolders: state.myFolders,
        }),
        publishedFolders: removePublishedFolder({
          folderId: payload,
          publishedFolders: state.publishedFolders,
        }),
      }),
    ],
    [
      R.equals(actionTypes.adjustFolderShares),
      () => ({
        ...state,
        myFolders: adjustFolderShares({
          folder: payload,
          myFolders: state.myFolders,
        }),
      }),
    ],
    [
      R.equals(actionTypes.removeFolderShares),
      () => ({
        ...state,
        myFolders: removeFolderShares({
          folderId: payload,
          myFolders: state.myFolders,
        }),
      }),
    ],
    [
      R.equals(actionTypes.deleteFolder),
      () => ({
        ...state,
        myFolders: withoutFolderId(payload, state.myFolders),
      }),
    ],
    [
      R.equals(actionTypes.deleteFolderItem),
      () => ({
        ...state,
        myFolders: withoutFolderItem(
          {
            folderId: payload.folderId,
            itemId: payload.itemId,
          },
          state.myFolders
        ),
      }),
    ],
    [
      R.equals(actionTypes.setNewPublished),
      () => ({
        ...state,
        hasNewPublished: payload,
      }),
    ],
    [
      R.equals(actionTypes.setNewShared),
      () => ({
        ...state,
        hasNewShared: payload,
      }),
    ],
    [
      R.equals(actionTypes.sortAscending),
      () => ({
        ...state,
        sort: payload,
      }),
    ],
    [
      R.equals(actionTypes.sortDescending),
      () => ({
        ...state,
        sort: payload,
      }),
    ],
    [
      R.equals(actionTypes.sortManual),
      () => ({
        ...state,
        sort: payload,
      }),
    ],
    [
      R.equals(actionTypes.sortSharedAscending),
      () => ({
        ...state,
        sharedSort: payload,
      }),
    ],
    [
      R.equals(actionTypes.sortSharedAuthor),
      () => ({
        ...state,
        sharedSort: payload,
      }),
    ],
    [
      R.equals(actionTypes.sortSharedDate),
      () => ({
        ...state,
        sharedSort: payload,
      }),
    ],
    [
      R.equals(actionTypes.sortSharedDescending),
      () => ({
        ...state,
        sharedSort: payload,
      }),
    ],
    [
      R.T,
      () => {
        throw new Error(`Unhandled action type: ${type}`)
      },
    ],
  ])(type)
}
